import { useState, useEffect, useLayoutEffect, useCallback } from "react";
import { format, parse, isBefore, isAfter, isEqual, addHours, differenceInMilliseconds, addDays } from "date-fns";  // Import necessary date-fns functions
import { CheckCircleIcon, ClockIcon, ExclamationCircleIcon, ChevronLeftIcon, ChevronRightIcon, PlusCircleIcon, ArrowsRightLeftIcon, MagnifyingGlassPlusIcon, MagnifyingGlassMinusIcon, ClipboardDocumentCheckIcon, ChevronDoubleDownIcon, QuestionMarkCircleIcon, UserCircleIcon, Square2StackIcon, CakeIcon, ChatBubbleBottomCenterIcon, PaperAirplaneIcon } from "@heroicons/react/20/solid";
import { useNavigate } from 'react-router-dom';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { ArrowLeftStartOnRectangleIcon, MinusCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import { useContext } from "react";
import { AuthContext } from "../AuthContext";
import ManagerNav from "./managernav";
import TaskHome from "./taskhome";
import Bottlenecks from "./bottlenecks";
import SubstepViewer from "./viewsubsteps";
import { UserAddIcon } from "@heroicons/react/20/solid";
import { ChevronDoubleRightIcon } from "@heroicons/react/20/solid";
import { Speech } from "openai/resources/audio/speech.mjs";



function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

/**
 * DailyTaskTimeline component displays a daily timeline of team tasks for managers,
 * including task progress, completion stats, filtering by role, zoom controls, and messaging.
 *
 * @component
 * @param {Object} props
 * @param {Date} props.date - The date for which to display the tasks. If provided, overrides the internal current date state.
 *
 * @returns {JSX.Element} The rendered DailyTaskTimeline component.
 *
 * @example
 * <DailyTaskTimeline date={new Date()} />
 *
 * @description
 * - Fetches and displays tasks for the selected date, grouped by start time.
 * - Allows filtering tasks by staff role.
 * - Shows a pie chart and progress bar for task completion statistics.
 * - Supports zoom in/out for task list scaling.
 * - Enables task priority changes, duplication, deletion, and task reassignment.
 * - Provides messaging functionality for each task.
 * - Displays bottleneck analysis and task outcomes.
 *
 * @dependencies
 * - React (useState, useEffect, useCallback, useLayoutEffect, useContext)
 * - date-fns (format, parse, addHours, addDays, isEqual, isBefore, isAfter, differenceInMilliseconds)
 * - Recharts (PieChart, Pie, Cell, Tooltip, ResponsiveContainer)
 * - Custom components: ManagerNav, Bottlenecks, SubstepViewer
 * - React Router (useNavigate)
 * - Various Heroicons for UI
 */
export default function DailyTaskTimeline({date}) {
  const user = useContext(AuthContext);

  const [tasks, setTasks] = useState([]);
  const [currentTask, setCurrentTask] = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [timeToNextTask, setTimeToNextTask] = useState(0);  // Time to next task in milliseconds
  const [elapsedTime, setElapsedTime] = useState(0);  // Time elapsed since last update
  const [progress, setProgress] = useState(0);  // Progress bar value
  const [currentDate, setCurrentDate] = useState(new Date()); // State to manage current date
  const [instructionsTaskId, setInstructionsTaskId] = useState(null);
const [instructionText, setInstructionText] = useState("");
  const [taskTally, setTaskTally] = useState({});
  const [staffMembers, setStaffMembers] = useState({});
  const Navigate = useNavigate();
  const [changeTask, setChangeTask] = useState(null);
  const [change, setChange] = useState([]);
const [openDropdown, setOpenDropdown] = useState(null);
const [roles, setRoles] = useState([]);
const [newRole, setNewRole] = useState("");
const [zoom, setZoom] = useState(1);
const [bottleneck, setBottleneck] = useState(null);
const [selectedTaskId, setSelectedTaskId] = useState(null);
const [openOutcomes, setOpenOutcomes] = useState(null);
const [sendMessage, setSendMessage] = useState(null);
const [taskMessages, setTaskMessages] = useState([]);
const [expandedCard, setExpandedCard] = useState(null);

  const getTaskEndTime = (task, taskStartTime) => {
    const rawEnd = String(task?.EndTime || '').substring(0, 8);
    if (rawEnd) {
      const parsedEnd = parse(rawEnd, 'HH:mm:ss', new Date());
      if (!isNaN(parsedEnd) && isAfter(parsedEnd, taskStartTime)) {
        return parsedEnd;
      }
    }
    return addHours(taskStartTime, 1);
  };

  // Fetch tasks from the backend with the selected date

  const handleTaskSelect = (taskId) => {
    setSelectedTaskId(taskId === selectedTaskId ? null : taskId); // Toggle selection
  };

  // if date comes from the parent component, set the current date to the date from the parent component

  useEffect(() => {
    if (date) {
      setCurrentDate(date);
    }
  }, [date]);


  const fetchData = useCallback(() => {
    const fetchTasks = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await fetch("https://api.insightos.co.uk/api/teamdailytasks", {
          method: "POST",
          headers: { 'Content-Type': 'application/json', }, credentials: 'include',
          body: JSON.stringify({ date: format(currentDate, "yyyy-MM-dd") }),
        });




       

        if (!response.ok) {
          throw new Error("Failed to fetch tasks.");
        }

        const data = await response.json();

        // Sort tasks by StartTime (chronological order)
        const sortedTasks = data.data.sort((a, b) =>
          parse(a.StartTime, "HH:mm:ss", new Date()) - parse(b.StartTime, "HH:mm:ss", new Date())
        );

        setTasks(sortedTasks);

        // create a tally of the tasks for the day

        const taskTally = sortedTasks.reduce((tally, task) => {
          if (tally[task.Task]) {
            tally[task.Task] += 1;
          } else {
            tally[task.Task] = 1;
          }
          return tally;
        }, {});

        console.log(taskTally);

        // now using.Name find out how different names are there in the taskTally object

        const staffMembers = sortedTasks.reduce((tally, task) => {
          if (tally[task.Name]) {

          } else {

            tally[task.Name] = 1;

          }

          return tally;

        }, {});

        // find out how many staff members are there in the staffMembers object

        setStaffMembers(staffMembers);

         // Get all the .Role from the sortedTasks array, remove duplicates, and then set them in state
setRoles([...new Set(sortedTasks.map((task) => task.Role))]);

          

        console.log(staffMembers);



        setTaskTally(taskTally);



        // Determine the current task based on the current time
        const now = new Date();
        const current = sortedTasks.find((task) => {
          const taskStartTime = parse(task.StartTime, "HH:mm:ss", new Date());
          const taskEndTime = getTaskEndTime(task, taskStartTime);
          return isEqual(taskStartTime, now) || (isBefore(taskStartTime, now) && isAfter(taskEndTime, now));
        });

        if (current) {
          setCurrentTask(current);
        }

        // Find the next task and calculate time to it
        const nextTask = sortedTasks.find((task) => {
          const taskStartTime = parse(task.StartTime, "HH:mm:ss", new Date());
          return isAfter(taskStartTime, now);
        });

        if (nextTask) {
          const nextTaskStartTime = parse(nextTask.StartTime, "HH:mm:ss", new Date());
          const timeDiff = differenceInMilliseconds(nextTaskStartTime, now);
          setTimeToNextTask(timeDiff);
        }
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }
    }

    fetchTasks();

  });



  useEffect(() => {
    fetchData();
  }, [currentDate]);





 

  // Update the current time every second
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);  // Cleanup on unmount
  }, []);

  // Update progress bar every second
  useEffect(() => {
    if (timeToNextTask > 0) {
      const intervalId = setInterval(() => {
        setElapsedTime((prevTime) => prevTime + 1000);  // Increase elapsed time by 1 second

        // Calculate the progress as a percentage of the total time
        const progressPercent = (elapsedTime / timeToNextTask) * 100;

        if (progressPercent < 100) {
          setProgress(progressPercent);
        } else {
          setProgress(100);
        }
      }, 1000);

      return () => clearInterval(intervalId); // Cleanup on unmount
    }
  }, [timeToNextTask, elapsedTime]);

  // Scroll to current task after tasks have been rendered
  useLayoutEffect(() => {
    if (currentTask && tasks.length > 0) {
      const currentTaskElement = document.getElementById(currentTask.TaskID); // Ensure we're getting the correct element
      if (currentTaskElement) {
        currentTaskElement.scrollIntoView({ behavior: 'smooth', block: 'center' }); // Scroll smoothly to the current task
      }
    }
  }, [currentTask, tasks]); // Re-run if currentTask or tasks change

  // Handle date change (Previous or Next)
  const handleDateChange = (direction) => {
    const newDate = addDays(currentDate, direction === 'next' ? 1 : -1);  // Add or subtract one day
    setCurrentDate(newDate);
  };

  const groupedTasks = tasks.reduce((groups, task) => {
    const taskStartTime = format(parse(task.StartTime, "HH:mm:ss", new Date()), "HH:mm");
    if (!groups[taskStartTime]) {
      groups[taskStartTime] = [];
    }
    groups[taskStartTime].push(task);
    return groups;
  }, {});

  // Prepare data for the Pie Chart
  const pieChartData = Object.entries(taskTally).map(([task, count]) => ({
    name: task,
    value: count,
  }));

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AF19FF"];

  // Handle priority change

const handlePriorityChange = async (taskId, action) => {


  // Find the task by ID
  const priorityLevels = ["Low", "Medium", "High"]; // Priority levels in order

  // match the task id with the task id in the tasks array
  const task = tasks.find((task) => task.TaskID === taskId);

  // find the index of the current priority level
  const currentPriorityIndex = priorityLevels.indexOf(task.Priority);

  let newPriorityIndex = currentPriorityIndex;

  if (action === "increase" && currentPriorityIndex < priorityLevels.length - 1) {
    newPriorityIndex += 1; // Move up in priority
  } else if (action === "decrease" && currentPriorityIndex > 0) {
    newPriorityIndex -= 1; // Move down in priority
  }

  const newPriority = priorityLevels[newPriorityIndex];

  console.log("New Priority:", newPriority);

  
  const id = taskId;

  try {

  const response = await fetch("https://api.insightos.co.uk/api/prioritychange", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: 'include',
    body: JSON.stringify({ id, priority: newPriority }), // Change "newPriority" to "priority"
  });
  
  

    if (!response.ok) {
      throw new Error("Failed to update priority.");
    }

    const data = await response.json();

    if (data.success) {

   fetchData();
   
      console.log("Priority updated successfully.");
    }
  }

  catch (error) {
    console.error("Error updating priority:", error);
  }

};


useEffect(() => {

  const fetchMessages = async () => {

    try {
      const response = await fetch(`https://api.insightos.co.uk/api/taskmessages/${sendMessage}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error("Failed to fetch messages.");
      }

      const data = await response.json();

      console.log(data.data);
      setTaskMessages(data.data);

    } catch (error) {
      console.error("Error fetching messages:", error);
    }

  };

  fetchMessages();

}

,[sendMessage]); // Fetch messages when sendMessage changes











const handleSendMessage = async (taskId) => {

  try {

    const response = await fetch("https://api.insightos.co.uk/api/sendtaskmessage", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
      body: JSON.stringify({ TaskID:taskId, content:instructionText }),
    });


    if (!response.ok) {
      throw new Error("Failed to send message.");
    }

    const data = await response.json();

    if (data.success) {
      console.log("Message sent successfully.");
      setSendMessage(null);
    }


    
  } catch (error) {
    console.error("Error sending message:", error);

  }
}



useEffect(() => {

  // get the tasks from the backend
  async function fetchTasks() {
    

    try {
      const response = await fetch("https://api.insightos.co.uk/api/tasks", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error("Failed to fetch tasks.");
      }

      const data = await response.json();


// push Break into the change array

const Break = "Break";





// Map over the data to extract the task strings, then split each string into individual tasks, and merge them into one array
const all = data.data
  .map((task) => task.Tasks) // Get the nested arrays of tasks
  .flat() // Flatten the array of arrays
  .map((task) => task.split(',')) // Split each task string by commas
  .flat(); // Flatten again to get one array of individual tasks

// Set the merged array to state

setChange([...new Set([...all, Break])]);
      






     
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  }

  fetchTasks();

}, [changeTask]); // Empty dependency array to run once



const handleNewTask = async (newTask, taskId) => {
  
  console.log("Changing task to:", newTask, "for task ID:", taskId);

  try {

    const response = await fetch("https://api.insightos.co.uk/api/changetask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
      body: JSON.stringify({ 
        id: taskId, // Use id as expected by the API
        Task: newTask 
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("API Error:", response.status, errorText);
      throw new Error(`Failed to update task: ${response.status} ${errorText}`);
    }

    const data = await response.json();

    console.log("API response:", data);

    // Check for message instead of success
    if (data.message === 'Task updated successfully') {

      console.log("Task updated successfully.");

      // Close the dropdown first
      setOpenDropdown(null);
      
      // Clear instruction text if it was set
      setInstructionText("");
      
      // Then refresh the data
      await fetchData();

    } else {
      console.error("API returned unexpected response:", data);
    }

  } catch (error) {
    console.error("Error updating task:", error);
    // Show user feedback
    alert("Failed to update task. Please try again.");
  }

};

 




useEffect(() => {

  console.log(newRole);

  // if newRole is all dont filter the tasks array

  if (newRole === "all") {
    fetchData();
    return;
  }


  // get the tasks state and then filter the newRole and .Role from the tasks array and re set in state

  const filteredTasks = tasks.filter((task) => task.Role === newRole);

  console.log(filteredTasks);

  setTasks(filteredTasks);

}, [newRole]);




  // Handle Zoom In
  const handleZoomIn = () => setZoom((prev) => prev + 0.1);
  const handleZoomOut = () => setZoom((prev) => (prev - 0.1 > 0.5 ? prev - 0.1 : 0.5));



// Function to calculate and return task completion percentages
const calculateTaskCompletion = () => {

  const tasksWithoutBreak = tasks.filter((task) => !task.Task.toLowerCase().includes("Break"));

  const completedTasks = tasksWithoutBreak.filter((task) => task.Completed === 1).length;
  
  const incompleteTasks = tasksWithoutBreak.filter((task) => task.Completed === 0).length;
  const totalTasks = tasksWithoutBreak.length;

  // Handle division by zero when there are no tasks
  const totalSafe = totalTasks || 1;
  const completedPercent = (completedTasks / totalSafe) * 100;
  const incompletePercent = (incompleteTasks / totalSafe) * 100;

  return { completedPercent, incompletePercent, completedTasks, incompleteTasks, totalTasks };
};



  const { completedPercent, incompletePercent, completedTasks, incompleteTasks, totalTasks } = calculateTaskCompletion();

  



  const duplicateTask = async (taskId) => {

    const token = localStorage.getItem('token');

    try {

      const response = await fetch(`https://api.insightos.co.uk/api/duplicatetask/${taskId}`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json', }, credentials: 'include',
      });

      if (!response.ok) {
        throw new Error("Failed to duplicate task.");
      }

      const data = await response.json();

      if (data.success) {
        console.log("Task duplicated successfully.");
        fetchData();
      }

    } catch (error) {
      console.error("Error duplicating task:", error);
    }

  };

  const handleDeleteTask = async (taskId) => {

    const token = localStorage.getItem('token');

    try {

      const response = await fetch(`https://api.insightos.co.uk/api/deletetask/${taskId}`, {
        method: "DELETE",
        headers: { 'Content-Type': 'application/json', }, credentials: 'include',
      });

      if (!response.ok) {
        throw new Error("Failed to delete task.");
      }

      const data = await response.json();

      if (data.success) {
        console.log("Task deleted successfully.");
        fetchData();
      }

    } catch (error) {

      console.error("Error deleting task:", error);

    }

  };











  return (
    <>
    <ManagerNav />

    {/* Main Content */}
    <div className="h-full flex flex-col bg-gradient-to-b from-indigo-100 via-sky-50 to-emerald-50" data-component="task-team-timeline">
      {/* Sticky Header */}
      <header className="sticky top-0 z-10 bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 backdrop-blur-xl border-b border-indigo-200/60 shadow-[0_12px_30px_rgba(99,102,241,0.2)] p-3 sm:p-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 w-full">
          <h1 className="text-lg sm:text-xl font-bold text-indigo-600 truncate">
            {format(currentDate, "EEE, MMM d, yyyy")}
          </h1>
          <input
            type="date"
            value={format(currentDate, "yyyy-MM-dd")}
            onChange={e => setCurrentDate(new Date(e.target.value))}
            data-component="task-team-date-picker"
            className="rounded-xl border border-indigo-200/70 bg-white/80 px-2 py-1 text-xs sm:text-sm font-medium text-indigo-900 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400"
            style={{ maxWidth: '140px' }}
          />
        </div>
    
    <div className="flex flex-wrap gap-2 items-center">
      {/* Role filter - shows on all screen sizes now */}
      <select
        onChange={(e) => setNewRole(e.target.value)}
        className="rounded-xl border border-indigo-200/70 bg-white/80 px-2 py-1 sm:px-3 sm:py-2 text-xs sm:text-sm font-medium text-indigo-900 shadow-sm hover:bg-white"
        data-component="task-team-role-filter"
      >
        <option value="all">All Roles</option>
        {roles.map((role, index) => (
          <option key={index} value={role}>
            {role}
          </option>
        ))}
      </select>
      </div>

      {/* Zoom controls */}
      <div className="flex items-center space-x-1">
        <button
          onClick={handleZoomOut}
          data-component="task-team-zoom"
          data-feature="zoom-out"
          className="rounded-xl border border-indigo-200/70 bg-white/75 p-1 sm:px-3 sm:py-2 text-indigo-900 shadow-sm hover:bg-white"
        >
          <MagnifyingGlassMinusIcon className="h-4 w-4 sm:h-5 sm:w-5" aria-hidden="true" />
        </button>
        <button
          onClick={handleZoomIn}
          data-component="task-team-zoom"
          data-feature="zoom-in"
          className="rounded-xl border border-indigo-200/70 bg-white/75 p-1 sm:px-3 sm:py-2 text-indigo-900 shadow-sm hover:bg-white"
        >
          <MagnifyingGlassPlusIcon className="h-4 w-4 sm:h-5 sm:w-5" aria-hidden="true" />
        </button>
      </div>
      
      <div className="flex items-center">
        <span className="text-xs sm:text-sm text-indigo-900">
          {format(currentTime, "HH:mm:ss")}
        </span>
      </div>
    </header>

    {/* Progress and Bottleneck Controls */}
    <div className="w-full bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 backdrop-blur-xl border-b border-indigo-200/60 p-2 sm:p-4">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:space-x-4">
        {bottleneck ? (
          <button
            onClick={() => setBottleneck(null)}
            data-feature="close-bottlenecks"
            type="button"
            className="inline-flex items-center gap-x-1 rounded-xl border border-white/20 bg-gradient-to-br from-rose-600/90 to-red-500/90 px-2 py-1 sm:px-3.5 sm:py-2.5 text-xs sm:text-sm font-semibold text-white shadow-lg shadow-rose-900/35 hover:from-rose-500/95 hover:to-red-400/95"
          >
            <ArrowLeftStartOnRectangleIcon aria-hidden="true" className="-ml-0.5 size-4 sm:size-5" />
            Back
          </button>
        ) : (
          <button 
            onClick={() => setBottleneck(tasks)}
            data-feature="open-bottlenecks"
            type="button"
            className="inline-flex items-center gap-x-1 rounded-xl border border-white/20 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 px-2 py-1 sm:px-3.5 sm:py-2.5 text-xs sm:text-sm font-semibold text-white shadow-lg shadow-indigo-950/40 hover:from-indigo-800/95 hover:to-indigo-600/95"
          >
            <ChevronDoubleDownIcon aria-hidden="true" className="-ml-0.5 size-4 sm:size-5" />
            Bottlenecks
          </button>
        )}

        <div className="w-full bg-white/70 border border-indigo-200/70 rounded-full h-4 sm:h-6 mb-2 sm:mb-4 overflow-hidden relative">
          <div className="flex h-full">
            {/* Completed segment */}
            <div 
              className="bg-gradient-to-r from-emerald-500 to-emerald-400 transition-all duration-300 ease-out" 
              style={{ width: `${completedPercent}%` }}
            />
            {/* Incomplete segment */}
            <div 
              className="bg-gradient-to-r from-rose-500 to-red-400 transition-all duration-300 ease-out" 
              style={{ width: `${incompletePercent}%` }}
            />
          </div>
          
          {/* Combined text overlay */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-xs font-medium">
            {totalTasks === 0 ? (
              <span>No tasks</span>
            ) : (
              <span className="text-[10px] sm:text-xs whitespace-nowrap">
                {completedTasks} Done • {incompleteTasks} Todo
                <span className="text-gray-300 mx-1 hidden sm:inline">|</span>
                <span className="sm:inline">{totalTasks} Total</span>
              </span>
            )}
          </div>
        </div>
      </div>
    </div>



    {tasks.length === 0 && (
      <div className="p-2 sm:p-4 rounded-2xl border border-red-200/60 bg-gradient-to-r from-rose-600/90 to-red-500/90 text-white shadow-lg shadow-rose-900/30 flex flex-col sm:flex-row items-center sm:justify-between gap-2">
        <ExclamationCircleIcon className="h-8 w-8 sm:h-12 sm:w-12" aria-hidden="true" />
        <p className="text-sm sm:text-lg text-center sm:text-left text-white-600">
          No tasks scheduled for today.
        </p>
        <button onClick={() => Navigate('/taskcalendar')}
        type="button"
        className="inline-flex items-center gap-x-1.5 rounded-xl border border-white/20 bg-gradient-to-br from-indigo-900/90 via-sky-600/90 to-emerald-500/90 px-2 py-1 sm:px-2.5 sm:py-1.5 text-xs sm:text-sm font-semibold text-white shadow-lg shadow-indigo-950/35 hover:from-indigo-800/95 hover:via-sky-500/95 hover:to-emerald-400/95"
      >
        <ClipboardDocumentCheckIcon aria-hidden="true" className="-ml-0.5 size-4 sm:size-5" />
        Task Manager 
      </button>
      </div>
    )}
      
    {/* Task List */}
    <div className="flex-auto overflow-auto bg-transparent p-2 sm:p-4 flex flex-col lg:flex-row">
      {/* Left Side - Task List */}
      {!bottleneck ? (
        <div className={`overflow-auto bg-transparent p-2 sm:p-4 transition-all duration-300 ${selectedTaskId || openOutcomes ? "w-full lg:w-2/3" : "w-full"}`}>

    {/* Wrap the content to apply the zoom without affecting layout */}
    <div
      className="transition-all duration-300"
      style={{ transform: `scale(${zoom})`, transformOrigin: "top left" }}
    >
    <ul className="space-y-2 sm:space-y-4">
  {Object.entries(groupedTasks).map(([startTime, tasksAtTime]) => (
    <li key={startTime} className="mb-4 sm:mb-6">
      {/* Time label */}
      <div className="mb-2 sticky top-0 z-10 bg-white/75 backdrop-blur-xl border border-indigo-200/70 p-2 rounded-xl shadow-sm">
        <h3 className="text-xs sm:text-sm font-medium text-indigo-900">Tasks at {startTime}</h3>
      </div>
      
      {/* Tasks grid - responsive layout */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-4">
        {tasksAtTime.map((task) => {
        const taskStartTime = parse(task.StartTime, "HH:mm:ss", new Date());
        const taskEndTime = getTaskEndTime(task, taskStartTime);
        let cardColor = "bg-gradient-to-br from-indigo-900/85 to-indigo-700/80";
        const isBreak = task.Break === 1;
        const completed = task.Completed === 1;
        const isIssue = task.Issue !== null;
        const helpReceived = task.HelpSuggestions !== null;
      

        


        // Set status icon: if not completed, show an X icon; if completed, show a check icon.
        let statusIcon = completed ? (
          <CheckCircleIcon className="h-6 w-6 text-white" aria-hidden="true" />
        ) : (
          <XCircleIcon className="h-6 w-6 text-white" aria-hidden="true" />
        );

let issueIcon = isIssue ? (
  <div className="flex items-center space-x-2">
          <ExclamationCircleIcon className="h-6 w-6 text-white animate-pulse" aria-hidden="true" />
          {helpReceived ? (
            <span className="text-xs bg-white p-2 text-emerald-500 rounded-full px-2 py-1">
              Help Received!
            </span>
          ) : (
          <span className="text-xs bg-white p-2 text-red-500 rounded-full px-2 py-1">
            Need Help!
          </span>
          )}
        </div>
        ) : null;


        let button = null;

        // If the task has passed its end time, mark it as overdue.
        if (isBefore(taskEndTime, currentTime)) {
          cardColor = "bg-gradient-to-br from-rose-600/85 to-red-500/80";
          // If the task is completed, override with the check icon.
          if (completed) {
            statusIcon = (
<button onClick={() => setOpenOutcomes(task.Outcome)}>
              <CheckCircleIcon className="h-12 w-12 text-emerald-300 animate-bounce" aria-hidden="true" />
                </button>            );
          }
        } else if (
          isEqual(taskStartTime, currentTime) ||
          (isBefore(taskStartTime, currentTime) && isAfter(taskEndTime, currentTime))
        ) {
          cardColor = "bg-gradient-to-br from-emerald-600/85 to-emerald-500/80";
          statusIcon = (
            <UserCircleIcon className="h-6 w-6 text-white" aria-hidden="true" />
          );
          
         
        }

        const isExpanded = expandedCard === task.TaskID;
        
        // Function to toggle expansion
        const toggleExpand = () => {
          setExpandedCard(isExpanded ? null : task.TaskID);
        };

        // Calculate break proportions for split color layout
        let breakPercentage = 0;
        let workPercentage = 100;
        if (isBreak && task.BreakDuration) {
          breakPercentage = Math.min((task.BreakDuration / 60) * 100, 100);
          workPercentage = 100 - breakPercentage;
        }
        
        return (
          <div
            key={task.TaskID}
            onClick={toggleExpand}
            className={classNames(
              isBreak ? "" : cardColor,
              "flex border border-white/25 backdrop-blur-xl flex-col w-full rounded-2xl shadow-lg shadow-indigo-950/20 text-white transition-all duration-300 relative overflow-hidden",
              "cursor-pointer hover:shadow-xl",
              isExpanded ? "md:p-4" : "p-2 md:p-4"
            )}
             style={isBreak ? {
          background: `linear-gradient(to bottom, #a78bfa 0%, #a78bfa ${breakPercentage}%, #a78bfa ${breakPercentage}%, #6d28d9 100%)`
             } : {}}
          >
            {/* Break time indicator for break tasks */}
            {isBreak && task.BreakStart && task.BreakEnd && (
              <div 
                className="absolute top-2 left-2 text-xs font-semibold text-indigo-900 bg-white/80 border border-indigo-200/70 px-2 py-1 rounded-xl z-10"
                style={{ width: '100%', minWidth: '60px' }}
              >
                {task.BreakStart} - {task.BreakEnd} ( Break )
              </div>
            )}
            {/* Mobile simplified card (when not expanded) */}
            <div className={`md:hidden ${isExpanded ? 'hidden' : 'block'} ${isBreak ? 'mt-8' : ''}`}>
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/85 text-indigo-900 font-semibold text-sm">
                    {task.Step}
                  </div>
                  <div>
                    <p className="font-bold text-sm truncate max-w-[150px]">{task.Task}</p>
                    <p className="text-xs opacity-90">{task.Name}</p>
                  </div>
                </div>
                <div className="flex items-center">
                  {statusIcon}
                  <ChevronDoubleRightIcon className="w-5 h-5 ml-1 text-white" />
                </div>
              </div>
            </div>
            
            {/* Full card content - always shown on desktop, shown on mobile only when expanded */}
            <div className={`${isExpanded ? 'block' : 'hidden md:block'} ${isBreak ? 'mt-8 md:mt-0' : ''} p-4`}>
              <div className="flex items-center justify-between">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/85 text-indigo-900 font-semibold">
                  {task.Step}
                </div>
                {task.ProjectName !== null && (
                  <p className="text-xs p-2 bg-white/80 border border-indigo-200/70 text-indigo-900 inline-block font-bebas rounded-xl">{task.ProjectName}</p>
                )}
                <button 
                  onClick={(e) => { 
                    e.stopPropagation(); 
                    handleTaskSelect(task.id);
                  }}
                  data-feature="toggle-task-details"
                >
                  <ChevronDoubleRightIcon className="w-10 h-10 md:w-16 md:h-16 text-white" />
                </button>
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    duplicateTask(task.TaskID);
                  }}
                  data-feature="duplicate-task_post"
                > 
                  <Square2StackIcon className="h-5 w-5 md:h-6 md:w-6 text-white" aria-hidden="true" />
                </button> 
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteTask(task.TaskID);
                  }}
                  data-feature="delete-task_delete"
                >
                  <XCircleIcon className="h-5 w-5 md:h-6 md:w-6 text-red-100" aria-hidden="true" />
                </button>
              </div>
              
              <p className="text-sm font-semibold mt-2">
                {task.Name} - {task.Role}
              </p>
              <p className="text-xs">{task.ProcessName}</p>
              <div className="flex items-center space-x-2 mt-2 flex-wrap">
                {statusIcon} {issueIcon}
                {task.Priority === "High" && (
                  <span className="text-xs bg-red-500 text-white rounded-full px-2 py-1">
                    High!
                  </span>
                )}
                {task.Priority === "Medium" && (
                  <span className="text-xs bg-yellow-500 text-white rounded-full px-2 py-1">
                    Medium
                  </span>
                )}
                {task.Priority === "Low" && (
                  <span className="text-xs bg-green-500 text-white rounded-full px-2 py-1">
                    Low
                  </span>
                )}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePriorityChange(task.TaskID, "decrease");
                  }}
                  data-feature="decrease-task-priority_post"
                  className="rounded-xl border border-white/20 bg-white/20 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-white/30"
                >
                  <MinusCircleIcon className="h-5 w-5 text-white" aria-hidden="true" />
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePriorityChange(task.TaskID, "increase");
                  }}
                  data-feature="increase-task-priority_post"
                  className="rounded-xl border border-white/20 bg-white/10 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-white/30"
                >
                  <PlusCircleIcon className="h-5 w-5 text-white" aria-hidden="true" />
                </button>
              </div>
              <p className="font-semibold mt-2">{task.Task}</p>
              {task.Description && (
                <p className="text-sm mt-2">{task.Description}</p>
              )}
              <p className="text-sm mt-2">
                <time>{format(taskStartTime, "HH:mm")}</time> -{" "}
                <time>{format(taskEndTime, "HH:mm")}</time>
              </p>
              
              <div className="flex items-center space-x-2 mt-2">
              
              {sendMessage === null &&  (
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    setSendMessage(task.TaskID);
                  }} 
                  data-feature="open-task-messages"
                  className="rounded-xl mr-2 sm:mr-3 border border-white/20 bg-white/80 px-2 py-1 sm:px-3 sm:py-2 text-xs sm:text-sm font-semibold text-indigo-900 shadow-sm hover:bg-white"
                >
                  <ChatBubbleBottomCenterIcon className="h-3 w-3" aria-hidden="true" />
                </button>
                )}
                {sendMessage === task.TaskID && (
                  <ChatBubbleBottomCenterIcon className="h-6 w-6 sm:h-8 sm:w-8 animate-bounce" aria-hidden="true" />
                )}

               
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setChangeTask(task.TaskID);
                    setOpenDropdown(openDropdown === task.TaskID ? null : task.TaskID);
                  }}
                  data-feature="toggle-task-reassign"
                  className="rounded-xl border border-white/20 bg-white/80 px-2 py-1 sm:px-3 sm:py-2 text-xs sm:text-sm font-semibold text-emerald-700 shadow-sm hover:bg-white"
                >
                  <ArrowsRightLeftIcon className="h-3 w-3" aria-hidden="true" />
                </button>
              </div>
              
              {/* Change Task Dropdown - positioned outside the flex container for better mobile visibility */}
              {openDropdown === task.TaskID && (
                <div 
                  className="mt-3 p-3 bg-white/80 backdrop-blur-xl rounded-xl border border-indigo-200/70 shadow-lg"
                  onClick={(e) => e.stopPropagation()} // Prevent card collapse when interacting with dropdown
                >
                  <div className="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-2">
                    <select
                      onChange={(e) => {
                        e.stopPropagation(); // Prevent card collapse
                        if (e.target.value) {
                          console.log("Selected task:", e.target.value, "for TaskID:", task.TaskID);
                          handleNewTask(e.target.value, task.TaskID);
                        }
                      }}
                      onClick={(e) => e.stopPropagation()} // Prevent card collapse when clicking select
                      className="flex-1 rounded-xl bg-white/85 px-3 py-2 text-sm font-semibold text-indigo-900 shadow-sm hover:bg-white border border-indigo-200/70"
                      defaultValue=""
                      data-component="task-reassign-select"
                      data-task-id={task.TaskID}
                    >
                      <option value="">Change Task</option>
                      {change.map((taskOption, index) => (
                        <option key={index} value={taskOption}>
                          {taskOption}
                        </option>
                      ))}
                    </select>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenDropdown(null);
                      }}
                      data-feature="close-task-reassign"
                      className="rounded-xl border border-white/20 bg-gradient-to-br from-rose-600/90 to-red-500/90 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:from-rose-500/95 hover:to-red-400/95"
                    >
                      <XCircleIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              )}
              
              {button}
            </div>
            
          </div>
        );
      })}
        </div>
      </li>
    ))}
</ul>

    </div>
  </div>
  ) : (
    <div className="w-full overflow-auto">
<Bottlenecks tasks={tasks} onTriggerParentEffect={fetchData}
 />
    </div>
  )}



  {/* Right Side - Input Box / Instructions */}
   {(selectedTaskId || openOutcomes || sendMessage) && (
      <div className={`w-full md:w-1/3 bg-gradient-to-b from-indigo-100/70 via-white/85 to-purple-100/70 backdrop-blur-xl ${window.innerWidth < 768 ? 'fixed inset-0 z-50 flex flex-col' : 'border-l border-indigo-200/60'} shadow-[0_12px_30px_rgba(99,102,241,0.2)] transition-all duration-300`}>
        {/* Mobile Header with Close Button */}
        <div className="md:hidden bg-gradient-to-r from-indigo-900 via-sky-600 to-emerald-500 text-white p-4 flex items-center justify-between shadow-md">
          <h2 className="text-lg font-semibold">
            {selectedTaskId ? 'Task Details' : sendMessage ? 'Messages' : 'Task Outcome'}
          </h2>
          <button
            onClick={() => {
              setSelectedTaskId(null);
              setOpenOutcomes(null);
              setSendMessage(null);
            }}
            data-feature="close-task-side-panel"
            className="p-2 hover:bg-white/20 rounded-full transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        </div>

        {/* Desktop Close button */}
        <button
          onClick={() => {
            setSelectedTaskId(null);
            setOpenOutcomes(null);
            setSendMessage(null);
          }}
          data-feature="close-task-side-panel"
          className="hidden md:block mb-4 mt-4 mx-4 px-3 py-1 border border-white/20 bg-gradient-to-br from-rose-600/90 to-red-500/90 text-white rounded-xl hover:from-rose-500/95 hover:to-red-400/95 flex items-center w-fit"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
          Close
        </button>

        {/* Content Area */}
        <div className="flex-1 overflow-auto p-4">
        {sendMessage && (
  <div className="w-full max-w-lg mx-auto p-1">
    {/* Gradient background container */}
    <div className="relative rounded-3xl p-1 bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 shadow-xl">
      {/* Glass effect inner box */}
      <div className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-3xl p-6">
        <h2 className="text-xl font-semibold text-white mb-3 drop-shadow">
          Send Message
        </h2>

        <div className="relative">
          <textarea
          onChange={(e => setInstructionText(e.target.value))}
            value={instructionText}
            data-component="task-message-input"
            className="w-full h-28 resize-none rounded-xl border border-white/20 bg-white/10 p-4 pr-12 text-sm text-white placeholder-white/70 backdrop-blur-sm focus:outline-none focus:ring-2 focus:ring-white/30 focus:border-transparent"
            placeholder="Type your message..."
          />

          <button
            onClick={() => handleSendMessage(sendMessage)}
            data-feature="send-task-message_post"
            className="absolute bottom-3 right-3 bg-white/20 hover:bg-white/30 p-2 rounded-full shadow-md transition backdrop-blur-md"
          >
            <PaperAirplaneIcon className="h-5 w-5 text-white animate-pulse " />
          </button>
        </div>
      </div>
      {taskMessages.length > 0 && (
        <div className="mt-10 p-4 bg-white/20 rounded-3xl backdrop-blur-md">
          <ul className="space-y-2">
            {taskMessages.map((message, index) => (
              <li key={index} className="text-sm text-white">
                <span className="font-semibold">{message.from}:</span> - {message.CreatedAt}
                {message.content}
              </li>
            ))}
          </ul>
          </div>
        )}
      
    </div>
  </div>
)}
        {/* Show SubstepViewer if selectedTaskId is set */}
        {selectedTaskId && <SubstepViewer taskData={selectedTaskId} />}
  
        {/* Show Outcome if openOutcomes is set */}
        {openOutcomes && (
          <div className="flex flex-col gap-2">
            <h2 className="text-lg font-semibold text-gray-800">Outcome for Task</h2>
            <p className="text-sm text-gray-600">{openOutcomes}</p>
          </div>
        )}
        </div>

        {/* Mobile Footer with Close Button (alternative position) */}
        <div className="md:hidden bg-white/60 backdrop-blur-xl p-4 border-t border-indigo-200/60">
          <button
            onClick={() => {
              setSelectedTaskId(null);
              setOpenOutcomes(null);
              setSendMessage(null);
            }}
            data-feature="close-task-side-panel"
            className="w-full py-3 border border-white/20 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 text-white rounded-xl hover:from-indigo-800/95 hover:to-indigo-600/95 transition-colors font-medium"
          >
            Close
          </button>
        </div>
      </div>
    )}
      </div>
    </div>
    </>
  );
}

